var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightingLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 34.001,
    viewBox: "0 0 134 34.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14146 7752.001)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-14146 -7722)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Intelligent Lighting")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14146 -7752.301)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M274.077.3,271.3,6.282,270.239,4.02H269.1l1.726,3.7h.922L275.216.3Z",
    transform: "translate(-224.008 0)",
    fill: "#e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.071,16.82h2.262V12.715a1.435,1.435,0,0,1,1.357-1.609,1.165,1.165,0,0,1,1.19,1.324v4.39h2.262V11.995a2.534,2.534,0,0,0-2.564-2.782,2.578,2.578,0,0,0-2.262,1.223h-.05V9.431H38.088v7.39ZM33.647,9.23a3.779,3.779,0,0,0-3.938,3.921,3.938,3.938,0,0,0,7.876,0A3.779,3.779,0,0,0,33.647,9.23m0,6.166c-1.072,0-1.625-.888-1.625-2.262s.57-2.262,1.625-2.262c1.072,0,1.659.888,1.659,2.262,0,1.357-.6,2.262-1.659,2.262M23.308,16.82h6.334V15.044H26.056v-.05l3.418-3.837V9.431H23.308v1.776h3.469v.05l-3.469,3.871Zm-2.9,0h2.262V9.431H20.409Zm-5.245,0h2.262V13.436a1.862,1.862,0,0,1,2.346-2.044h.05V9.448a1.207,1.207,0,0,0-.469-.05,2.132,2.132,0,0,0-1.977,1.273h-.05V9.448H15.165Zm-4.156-1.408a1.673,1.673,0,0,1-1.726-1.642h5.329a4.641,4.641,0,0,0-1.29-3.653,3.53,3.53,0,0,0-2.48-.888,3.716,3.716,0,0,0-3.77,3.9,3.733,3.733,0,0,0,3.921,3.938,3.85,3.85,0,0,0,2.262-.67,2.968,2.968,0,0,0,1.24-1.743H12.333a1.337,1.337,0,0,1-1.324.754m-.117-4.591a1.451,1.451,0,0,1,1.424,1.458H9.3a1.564,1.564,0,0,1,1.592-1.458m-8.311,6H4.943L7.524,9.414H5.245L3.8,14.173H3.77L2.329,9.414H0ZM20.409,6.8h2.262V8.811H20.409Z",
    transform: "translate(0 -5.411)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightingLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lighting-logo.89eac225d1259565117446489b69d789.svg";